import { Box, List, ListItemButton, ListItemText } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useNavigate } from "react-router"

import './SubList.scss'

export const SubList = ({ listRoutes, parentPath, horizontal = false }: any) => {

    const navigate = useNavigate()

    const isExactPath = (original: any) => {

        // const sublink = original.split(parentPath)?.[1] || ''
        // console.log(sublink, window.location.pathname.split(parentPath)?.[1]);

        return original === (window.location.pathname.split(parentPath)?.[1] || '/')
    }

    return (
        <List
            className="SubList"
            sx={horizontal ? { display: 'flex', flexDirection: 'row', flexWrap: 'wrap', columnGap: 0.5, p: 0.5 } : undefined}
        >
            {
                listRoutes.map((item: any) => {

                    const selected = isExactPath(item.link)

                    return (
                        <ListItemButton
                            className={horizontal ? 'py-1' : 'py-2 LayoutPrimary__Link'}
                            onClick={() => navigate(`.${item.link}`)}
                            selected={selected}
                            key={item.link}
                            sx={horizontal ? {
                                width: 'auto',
                                flex: '0 0 auto',
                                borderRadius: 2,
                                whiteSpace: 'nowrap',
                                bgcolor: selected ? 'rgba(158, 0, 84, 0.08)' : 'transparent',
                                '&:hover': {
                                    bgcolor: 'rgba(158, 0, 84, 0.04)',
                                },
                            } : undefined}
                        >
                            <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center' }}>
                                {
                                    horizontal && item.icon &&
                                    <FontAwesomeIcon
                                        icon={item.icon}
                                        style={{ fontSize: 15, marginRight: 6, color: selected ? 'var(--color-primary)' : 'inherit' }}
                                    />
                                }
                                <ListItemText className='text-wrap'>{item.title}</ListItemText>
                            </Box>
                        </ListItemButton>
                    )
                })
            }

        </List>
    )
}